// AUDIT_VAL-70 L1 - the amount fields of "Record a payment made outside Stripe" (SnapshotPaymentsSection).
/** AUDIT_VAL-70 L1: what was paid outside Stripe, so it counts as upgrade credit.
 *  WORDING FOR OWNER APPROVAL. The server (snapshot_payments.AMOUNT_LABEL / CURRENCY_LABEL /
 *  AMOUNT_REQUIRED) holds the same words. */
export const AMOUNT_LABEL = 'Amount paid'
export const CURRENCY_LABEL = 'Currency'
export const AMOUNT_REQUIRED = 'Enter the amount paid, more than zero.'
export const DEFAULT_CURRENCY = 'USD'

/** VAL-70-FOLLOWUPS F1: the one reason that may record $0 (server: snapshot_payments.COMPLIMENTARY). */
export const COMPLIMENTARY = 'Complimentary'

const isComplimentary = (reason?: string) =>
  (reason ?? '').trim().toLowerCase() === COMPLIMENTARY.toLowerCase()

/** Whole cents from a typed dollar amount, or null when it is not a number above zero.
 *  F1: with the reason "Complimentary", 0 is allowed too. */
export function toCents(typed: string, reason?: string): number | null {
  const t = typed.trim()
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null
  const cents = Math.round(parseFloat(t) * 100)
  return cents > 0 || (cents === 0 && isComplimentary(reason)) ? cents : null
}
